import React from 'react';
import { Check } from 'lucide-react';
import { C } from '../shared';

export const Stepper = ({ steps, current, onJump, reachable }) => (
  <ol className="flex items-center flex-wrap gap-y-2" data-testid="rj-stepper">
    {steps.map((s, i) => {
      const done = i < current;
      const active = i === current;
      const can = reachable(i);
      return (
        <li key={s.id} className="flex items-center">
          <button type="button" disabled={!can} onClick={() => can && onJump(i)} data-testid={`rj-step-${s.id}`}
            className={`flex items-center gap-1.5 text-xs transition-colors ${can ? 'hover:opacity-80' : 'cursor-not-allowed'}`}
            style={{ color: active ? C.blue : done ? C.green : C.slate, fontWeight: active ? 600 : 400 }}>
            <span className="w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-semibold"
              style={{ background: done ? C.green : active ? C.blue : 'rgba(136,150,168,0.15)', color: done || active ? 'white' : C.slate }}>
              {done ? <Check className="w-3 h-3" /> : i + 1}
            </span>
            {s.label}
          </button>
          {i < steps.length - 1 && <span className="mx-2 w-6 h-px" style={{ background: i < current ? C.green : 'rgba(136,150,168,0.3)' }} />}
        </li>
      );
    })}
  </ol>
);
